import { BaseService } from '@/api/services/BaseService'
import { COMMON_SCOPES, sdk } from '@/authentication/coodeSdkConfig'
import { ApiResponse } from '@/api/models/ApiResponse'
import { GetLocalesResponse } from '@/api/models/translation/GetLocalesResponse'
import { GetPhrasesResponse } from '@/api/models/translation/GetPhrasesResponse'

export class TranslationService extends BaseService {
    constructor() {
        super({
            baseURL: import.meta.env.VITE_TRANSLATION_SERVICE_API_URL,
            accessTokenProvider: () => sdk?.auth?.getToken(COMMON_SCOPES.TRANSLATION_SERVICE),
        })
    }

    private get cacheBypassConfig() {
        return {
            headers: {
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                Pragma: 'no-cache',
                Expires: '0',
            },
        }
    }

    async getLocales(): Promise<GetLocalesResponse> {
        const response = await this.get<ApiResponse<GetLocalesResponse>>({
            url: `locales/${import.meta.env.VITE_TRANSLATION_PROJECT_ID}`,
            additionalConfig: this.cacheBypassConfig,
        })

        return response.data.result
    }

    async getPhrases(localeCode: string): Promise<GetPhrasesResponse> {
        const response = await this.get<ApiResponse<GetPhrasesResponse>>({
            url: `phrases/${import.meta.env.VITE_TRANSLATION_PROJECT_ID}/${localeCode}`,
            additionalConfig: this.cacheBypassConfig,
        })

        return response.data.result
    }

    async sync(): Promise<void> {
        await this.post<ApiResponse<void>>({
            url: 'synchronizer',
            body: {
                projectId: import.meta.env.VITE_TRANSLATION_PROJECT_ID,
            },
        })
    }
}
